

























































import Swal from 'sweetalert2';
import { defineComponent, PropType } from 'vue'
import { Linha } from '~/store/docs'
import DialogModal from '~/components/DialogModal.vue';

import { doc_linha_sevice } from '~/store/docs';

type DataType = {
    editando: boolean
    salvando: boolean
    excluindo: boolean
    complemento: string
    valor: string
}

export default defineComponent({
    components: {
        DialogModal
    },
    props: {
        linha: {
            required: true,
            type: Object as PropType<Linha>
        }
    },
    data(): DataType {
        return {
            editando: false,
            salvando: false,
            excluindo: false,
            complemento: this.linha.complemento,
            valor: this.linha.valor.toLocaleString('pt-br', {
                minimumFractionDigits: 2
            })
        }
    },
    methods: {
        async excluir(): Promise<void> {
            try {
                let { isConfirmed } = await Swal.fire({
                    icon: 'warning',
                    title: "Deseja excluir a linha?",
                    showCancelButton: true,
                    cancelButtonText: "Não",
                    confirmButtonText: 'Sim',
                    target: 'dialog'
                })
                if (!isConfirmed) {
                    return
                }

                this.excluindo = true;
                let response = await doc_linha_sevice.remove({
                    codigo_doc: this.linha.codigo_doc,
                    codigo_linha: this.linha.codigo_linha
                })

                this.$emit('updated', response.linhas)
                await Swal.fire({
                    target: `dialog`,
                    icon: 'success',
                    title: "Registro excluído com sucesso"
                })

            } catch (error) {
                let text = 'Não foi possível excluir o registro'
                if (error instanceof Error) {
                    text = error.message
                }
                await Swal.fire({
                    target: `dialog`,
                    icon: 'error',
                    title: "Oops",
                    text
                })
            }
            this.excluindo = false
        },
        editar() {
            this.editando = true
        },
        async save() {
            try {
                this.salvando = true
                let response = await doc_linha_sevice.atualizar({
                    codigo_doc: this.linha.codigo_doc,
                    codigo_linha: this.linha.codigo_linha,
                    complemento: this.complemento,
                    valor: Number(this.valor.replace(/\D+/igm, '')) / 100
                })

                this.$emit('updated', response.linhas)
                await Swal.fire({
                    target: `.dialog-${this.linha.codigo_linha}`,
                    icon: 'success',
                    title: "Registro atualizado com sucesso"
                })

                this.editando = false
            } catch (error) {
                let text = 'Não foi possível salvar o registro'
                if (error instanceof Error) {
                    text = error.message
                }
                await Swal.fire({
                    target: `.dialog-${this.linha.codigo_linha}`,
                    icon: 'error',
                    title: "Oops",
                    text
                })
            }
            this.salvando = false
        }
    },
    watch: {
        valor: function (value) {

            this.valor = (value.replace(/\D+/igm, '') / 100).toLocaleString('pt-br', {
                minimumFractionDigits: 2
            })
        }
    }
})

